import CookieConsent from "react-cookie-consent";
import Policy from "../../assets/Polityka.pdf"

const Cookie = () => {
  return (
    <>
      <CookieConsent
        cookieName="cookies"
        buttonText="Rozumiem"
        style={{
          background: "#ffede3",
          textAlign: "center",
          justifyContent: "center",
          color: '#000000',
        }}
        buttonStyle={{
          border: "none",
          borderRadius: "4px",
          outline: "none",
          background: "var(--color-second)",
          padding: "10px",
          color: "#fff",
          fontSize: "1em",
        }}
        expires={365}
      >
        Wchodząc na stronę akceptujesz cookie i 
        <a href={Policy} download style={{ color: "var(--color-active)", fontWeight: "700" }}> politykę prywatności. </a>
      </CookieConsent>
    </>
  );
};

export default Cookie;
